import { render, staticRenderFns } from "./TaxRates.vue?vue&type=template&id=1729c182&scoped=true"
import script from "./TaxRates.vue?vue&type=script&lang=js"
export * from "./TaxRates.vue?vue&type=script&lang=js"
import style0 from "./TaxRates.vue?vue&type=style&index=0&id=1729c182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1729c182",
  null
  
)

export default component.exports